import { createSlice } from "@reduxjs/toolkit";

export interface CallLogResult {
    callLogId: number,
    site: string,
    categoryName: string,
    categoryDescription: string,
    notes: string,
    status: string,
    createdDate: Date,
    updatedDate: Date,
    createdBy: string,
    updatedBy: string,
    totalRecords: number
}

export interface CallLogSummary {
    site: string,
    categoryName: string,
    categoryDescription: string,   
    totalRecords: number
}

export interface CallLogState {
    data: CallLogResult[] | null,
    subtotal: CallLogSummary[] | null
}

const initialState: CallLogState = {
    data: null,
    subtotal: null
}

const CallLogSlice = createSlice({
    name: 'CallLog',
    initialState,
    reducers: {
        setResultData(state: CallLogState, action: any) {
            state.data?.splice(0);
            state.subtotal?.splice(0);

            if (action.payload.data?.length > 0) {
                state.data = [];
                action.payload.data.map((obj: CallLogResult) => {
                    if (state.data != null) {
                        state.data.push(obj);
                    }
                });
            }

            if (action.payload.subtotal?.length > 0) {
                state.subtotal = [];
                action.payload.subtotal.map((obj: CallLogSummary) => {
                    if (state.subtotal != null) {
                        state.subtotal.push(obj);
                    }
                });
            }
        },
        clearResultData(state: CallLogState, action: any) {
            state.data?.splice(0);
            state.subtotal?.splice(0);
        }
    }
});

export const CallLogActions = CallLogSlice.actions;

export default CallLogSlice;